import { Service } from './service';

const url = {
  GET_LENDER_BO_BY_COMPANY_ID: '/api/v1/loan/getLenderBOByCompanyId',
  ENABLE_PLATFORM_LOAN_SUBMISSION:
    '/api/v1/lender/enablePlatformLoanSubmissionFeature',
  LENDER_ALL_FORECLOSURE_ATTORNEYS: '/api/v1/lender/getAllForeclosureAttorneys',
  GET_FORECLOSURE_ATTORNEY_BY_LOAN_ID: '/api/v1/lender/getForeclosureAttorneyByLoanId'
};

export class LenderService extends Service {
  getLenderBOByCompanyId(companyId) {
    return this.get(url.GET_LENDER_BO_BY_COMPANY_ID, { companyId });
  }
  enablePlatformLoanSubmissionFeature(lenderId: number) {
    return this.post(
      `${url.ENABLE_PLATFORM_LOAN_SUBMISSION}?lenderId=${lenderId}`,
      {}
    );
  }
  getAllForeclosureAttorneys() {
    return this.get(url.LENDER_ALL_FORECLOSURE_ATTORNEYS);
  }
  getForeclosureAttorneyByLoanId(loanId) {
    return this.get(url.GET_FORECLOSURE_ATTORNEY_BY_LOAN_ID, { loanId });
  }
}
